import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'


import vuetify from './plugins/vuetify.js'
import 'vuetify/styles'; // Ensure you are importing the styles


import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import ms from './locales/ms.json';
const messages = {
    en: en,
    ms: ms
};
  
const i18n = createI18n({
    locale: 'ms', // default locale
    messages,
});

import apiClient, { setAuthToken } from './plugins/axios';
const token = process.env.VUE_APP_API_TOKEN; // Replace with your logic to get the token
setAuthToken(token);



// import 'pagepiling.js/dist/jquery.pagepiling.css'; // Import the CSS

const app = createApp(App)
app.config.warnHandler = () => {
  // silence all warnings
}
app.config.globalProperties.$http = apiClient;
app.use(router)
app.use(store)
app.use(vuetify)
app.use(i18n)
app.mount('#app')
